import { render, staticRenderFns } from "./SearchOldExpenses.vue?vue&type=template&id=08d4a3cc&scoped=true&"
import script from "./SearchOldExpenses.vue?vue&type=script&lang=js&"
export * from "./SearchOldExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4a3cc",
  null
  
)

export default component.exports